/**
 * @file experienceDetailsSidebar.component.tsx
 * @path apps/website/src/features/experiences/components/experienceDetailsSidebar.component.tsx
 * @description UI component with conditional internal/external booking link support.
 */

import { Button, Card } from "@sirbastians/ui";
import { Link } from "react-router-dom";

import { ExperienceDetail } from "@/features";

export const SidebarSection = ({ data }: { data: ExperienceDetail }) => {
  // ✨ Check if the link is external
  const isExternalBooking =
    data.bookingLink?.startsWith("http") || data.bookingLink?.startsWith("//");

  return (
    <aside className="lg:col-span-1 lg:sticky lg:top-32">
      <Card className="bg-card/40 backdrop-blur-md border border-border neuro-well rounded-3xl p-8 space-y-8">
        <div className="flex flex-col space-y-1">
          <span className="text-[10px] font-montserrat font-black uppercase tracking-[0.3em]">
            Rate
          </span>
          <div className="font-bold text-4xl text-foreground">
            {data.price.amount === 0 ? (
              "Complimentary"
            ) : (
              <>
                {data.price.prefix && (
                  <span className="text-xl font-normal text-muted-foreground mr-1.5">
                    {data.price.prefix}
                  </span>
                )}
                <span className="text-xl font-medium mr-1">
                  {data.price.currency === "ZAR" ? "R" : "$"}
                </span>
                {data.price.amount.toLocaleString()}
              </>
            )}
          </div>
        </div>

        <div className="space-y-4">
          <Button
            asChild
            variant="accent"
            size="lg"
            className="w-full rounded-xl font-montserrat font-bold uppercase tracking-widest text-xs"
          >
            {/* ✨ CONDITIONAL LINK RENDERING */}
            {isExternalBooking ? (
              <a
                href={data.bookingLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Now
              </a>
            ) : (
              <Link to={data.bookingLink}>Book Now</Link>
            )}
          </Button>
        </div>
      </Card>
    </aside>
  );
};
